import exclusiveNeoApi from 'shared_js/api/exclusiveApi/exclusiveNeoApi';
import { NEO_CONFIG_PAYMENT_CODE_MAPPING } from 'shared_js/utils/buka20-constants';

const initialState = {
  paymentNeoConfigs: undefined,
};

const getters = {
  getIsPaymentNeoConfigsLoaded(state) {
    return state.paymentNeoConfigs !== undefined;
  },
  getDefaultPaymentMethodType(state) {
    const defaultPaymentCode =
      state.paymentNeoConfigs?.['default-payment-method'] || 'wallet';
    return NEO_CONFIG_PAYMENT_CODE_MAPPING[defaultPaymentCode];
  },
};

const actions = {
  async fetchPaymentConfigs({ commit, getters }) {
    if (getters.getIsPaymentNeoConfigsLoaded) return;

    try {
      const { data } = await exclusiveNeoApi.retrieveNeoConfig([
        'mitra-payment-method-config',
      ]);
      commit('setPaymentNeoConfigs', data?.[0]?.data || {});
    } catch (e) {
      commit('setPaymentNeoConfigs', {});
    }
  },
};

const mutations = {
  setPaymentNeoConfigs(state, paymentNeoConfigs) {
    state.paymentNeoConfigs = paymentNeoConfigs;
  },
};

export default {
  state: () => ({ ...initialState }),
  getters,
  actions,
  mutations,
};
